const serialNumbers = [
  {
    serNum: [0, 20_000],
    year: "1927",
  },
  {
    serNum: [20_001, 40_000],
    year: "1927 - 1937",
  },
  {
    serNum: [40_001, 200_000],
    year: "1938 - 1942",
  },
  {
    serNum: [200_001, 300_000],
    year: "1941 - 1944",
  },
  {
    serNum: [300_001, 500_000],
    year: "1945 - 1946",
  },
  {
    serNum: [620_000, 700_000],
    year: "1947 - 1950",
  },
  {
    serNum: [620_000, 700_000],
    year: "1948 - 1950",
  },
  {
    serNum: [700_001, 725_000],
    year: "1951",
  },
  {
    serNum: [725_001, 880_000],
    year: "1952",
  },
  {
    serNum: [888_000, 999_000],
    year: "1953",
  },
  {
    serNum: [0, 50_000],
    year: "1954",
  },
  {
    serNum: [50_001, 150_000],
    year: "1955",
  },
  {
    serNum: [150_001, 200_000],
    year: "1956",
  },
  {
    serNum: [250_000, 350_000],
    year: "1957",
  },
  {
    serNum: [350_001, 450_000],
    year: "1958",
  },
  {
    serNum: [450_001, 550_000],
    year: "1959",
  },
  {
    serNum: [550_001, 650_000],
    year: "1960",
  },
  {
    serNum: [650_001, 755_000],
    year: "1961",
  },
  {
    serNum: [755_001, 865_000],
    year: "1962",
  },
  {
    serNum: [865_001, 1_000_000],
    year: "1963",
  },
  {
    serNum: [1_105_000, 1_275_000],
    year: "1964",
  },
  {
    serNum: [1_105_000, 1_275_000],
    year: "1965",
  },
  {
    serNum: [1_275_001, 1_485_000],
    year: "1966",
  },
  {
    serNum: [1_485_001, 1_710_000],
    year: "1967",
  },
  {
    serNum: [1_710_001, 1_945_000],
    year: "1968",
  },
  {
    serNum: [1_945_001, 2_240_000],
    year: "1969",
  },
  {
    serNum: [2_240_001, 2_590_000],
    year: "1970",
  },
  {
    serNum: [2_590_001, 2_890_000],
    year: "1971",
  },
  {
    serNum: [2_890_001, 3_200_000],
    year: "1972",
  },
  {
    serNum: [3_200_001, 3_570_000],
    year: "1973",
  },
  {
    serNum: [3_570_001, 3_865_000],
    year: "1974",
  },
  {
    serNum: [3_865_001, 4_115_000],
    year: "1975",
  },
  {
    serNum: [4_115_001, 4_260_000],
    year: "1976",
  },
  {
    serNum: [5_085_000, 5_430_000],
    year: "1977",
  },
  {
    serNum: [5_430_001, 5_865_000],
    year: "1978",
  },
  {
    serNum: [5_865_001, 6_205_000],
    year: "1979",
  },
  {
    serNum: [6_205_001, 6_560_000],
    year: "1980",
  },
  {
    serNum: [6_560_001, 7_130_000],
    year: "1981",
  },
  {
    serNum: [7_130_001, 7_600_000],
    year: "1982",
  },
  {
    serNum: [7_600_001, 8_375_000],
    year: "1983",
  },
  {
    serNum: [8_375_001, 8_785_000],
    year: "1984",
  },
  {
    serNum: [8_785_001, 9_155_000],
    year: "1985",
  },
  {
    serNum: [9_155_001, 9_860_000],
    year: "1986",
  },
  {
    serNum: [9_860_001, 9_900_000],
    year: "1987",
  },
  {
    serNum: "R",
    year: "1987",
    range: [1, 598_199],
  },
  {
    serNum: "R",
    year: "1988",
    range: [598_200, 999_999],
  },
  {
    serNum: "L",
    year: "1989",
    range: [980_000, 999_999],
  },
  {
    serNum: "E",
    year: "1990",
    range: [1, 999_999],
  },
  {
    serNum: "X",
    year: "1991",
    range: [1, 999_999],
  },
  {
    serNum: "N",
    year: "1991",
    range: [1, 999_999],
  },
  {
    serNum: "C",
    year: "1992",
    range: [1, 999_999],
  },
  {
    serNum: "S",
    year: "1993",
    range: [1, 860_879],
  },
  {
    serNum: "S",
    year: "1994",
    range: [860_880, 999_999],
  },
  {
    serNum: "W",
    year: "1995",
    range: [1000, 999_999],
  },
  {
    serNum: "T",
    year: "1996",
    range: [1, 999_999],
  },
  {
    serNum: "U",
    year: "1997",
    range: [1, 932_143],
  },
  {
    serNum: "U",
    year: "1998",
    range: [932_144, 999_999],
  },
  {
    serNum: "A",
    year: "1999",
    range: [1, 999_999],
  },
  {
    serNum: "P",
    year: "2000",
    range: [1, 999_999],
  },
  {
    serNum: "K",
    year: "2000",
    range: [1, 999_999],
  },
  {
    serNum: ["K", "Y"],
    year: "2001",
  },
  {
    serNum: "Y",
    year: "2002",
  },
  {
    serNum: "F",
    year: "2003",
  },
  {
    serNum: "F",
    year: "2004",
  },
  {
    serNum: "F",
    year: "2005",
  },
  {
    serNum: "D",
    year: "2005",
  },
  {
    serNum: ["D", "Z"],
    year: "2006",
  },
  {
    serNum: ["M", "Z"],
    year: "2007",
  },
  {
    serNum: ["M", "V"],
    year: "2008",
  },
  {
    serNum: "V",
    year: "2009",
  },
  {
    serNum: "G",
    year: "2010",
  },
];
